<template>
  <div>
    <span v-for="(letter, key) in word" class="letter" :style="{
      'color' : key in style ? style [key] [0] : '',
      'font-size' : key in style ? style [key] [1] + 'px' : ''
    }">{{ letter }}</span>
  </div>
</template>

<script>
  import { rand } from '@/legacy/lib/util';

  export default {
    props: {
      value: String
    },

    data () {
      return {
        style: {},
        colours: [
          '#3e9cdc', '#1b9601', '#f8b700', '#c8b038',
          '#e5b30f', '#b1997f', '#9d9080', '#db2300'
        ]
      }
    },

    mounted () {
      setInterval (() => {
        for (let i = 0; i < this.value.length; i++) {
          this.$set (this.style, i, [
            this.colours [rand (0, this.colours.length)],
            rand (12, 16)
          ]);
        }
      }, 500);
    },

    computed: {
      word () {
        return this.value.split ('');
      }
    }
  };
</script>

<style scoped lang="scss">
  .letter {
    transition: all 0.5s;
  }

  //   display: inline-block;
  //   animation-name: spin;
  //   animation-duration: 5000ms;
  //   animation-iteration-count: infinite;
  //   animation-timing-function: linear;
  // }

  // @keyframes spin {
  //   from {
  //     transform:rotate(0deg);
  //   }
  //   to {
  //     transform:rotate(360deg);
  //   }
  // }
</style>